import { Localized } from "@fluent/react";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { useState } from "react";
import { AppId } from "../../../app/appTypes";
import { useAppDispatch } from "../../../app/hooks";
import { DocumentLanguageSelect } from "../controls/DocumentLanguageSelect";
import { updateDocumentField } from "../documentsApi";
import { DocumentLanguages } from "../documentTypes";
import { SaveButton } from "../../../app/components/SaveButton";
import { CloseButton } from "../../../app/components/CloseButton";

export interface EditDocumentLanguageDialogProps {
    documentId: AppId;
    defLanguage: DocumentLanguages;
    onSuccess: (newValue: DocumentLanguages) => void;
    onCancel: () => void;
}

export const EditDocumentLanguageDialog = (props: EditDocumentLanguageDialogProps) => {
    const dispatch = useAppDispatch();
    const [saving, setSaving] = useState(false);
    const [language, setLanguage] = useState(props.defLanguage);

    const handleOkClick = () => {
        setSaving(true);
        dispatch(
            updateDocumentField({
                documentId: props.documentId,
                fieldName: "language",
                value: language,
            })
        )
            .then(unwrapResult)
            .then(() => {
                props.onSuccess(language);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                setSaving(false);
            });
    };

    return (
        <Dialog open={true} fullWidth maxWidth="xs">
            <DialogTitle
                sx={{
                    bgcolor: (theme) => theme.palette.grey[200],
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    py: 0.75,
                }}
            >
                <Localized id="edit">Edycja</Localized>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ marginTop: 2 }}>
                    <DocumentLanguageSelect
                        defaultValue={language}
                        required={true}
                        onChange={(value) => setLanguage(value)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <SaveButton loading={saving} onClick={handleOkClick} />
                <CloseButton loading={saving} onClick={props.onCancel} />
            </DialogActions>
        </Dialog>
    );
};
